import React, { useState, useEffect } from 'react';
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './TopBar.css';
import IconMan from '../media/imagen/IconMan.svg';

const TopBar = ({ isCollapsed }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [companyName, setCompanyName] = useState("Загрузка...");
  const navigate = useNavigate();
  
  // Загрузка названия компании
  useEffect(() => {
    const fetchCompanyName = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) return;
        
        const response = await fetch('http://185.250.149.189:8000/api/v1/Company', {
          headers: { 'Authorization': `Token ${token}` }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.Company && data.Company.name) {
            setCompanyName(data.Company.name);
          }
        }
      } catch (error) {
        console.error('Ошибка загрузки компании:', error);
        setCompanyName("Компания");
      }
    };
    
    fetchCompanyName();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  return (
    <div className={`top-bar ${isCollapsed ? 'collapsed' : ''}`}> 
      <div className="user-profile" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <img src={IconMan} alt="IconMan" className="user-icon" />
        <span className="user-name">{companyName}</span>
        
        {isMenuOpen && (
          <div className="dropdown-menu">
            <button className="dropdown-item" onClick={handleLogout}>
              <FaSignOutAlt className="dropdown-icon" />
              Выйти из системы
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBar;